import { setupRenderers } from './renderers/index.ts';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './theme.css';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

setupRenderers();
createRoot(container).render(<App />);
